import React, { useState } from 'react';
import Grid from '@mui/material/Grid2';

import { 
  Character,
} from "@dndModels";

import ModalOrDrawer from "@components/display/ModalOrDrawer";
import CharacterManageInventory from "@dndComponents/character/inventory/manage/CharacterManageInventory";
import DandDButtonBox from '@dndComponents/DandDButtonBoxSimple';

interface Props {
  character: Character;
  disabled: boolean;
  shared: boolean;
}

export default function CharacterManageInventoryButton({
  character,
  disabled,
  shared,
}: Props) {
  const [open, setOpen] = useState(false);

  const renderExtras = () => {
    return (
      <ModalOrDrawer
        open={ open } 
        onClose={() => {
          setOpen(false);
          character.subscription_holder.modalClosed();
        }}>
        { open &&
          <Grid container spacing={0} direction="row">
            <Grid
              size={{
                xs: 12
              }}>
              <CharacterManageInventory
                char={character}
                shared={shared}
              />
            </Grid>
          </Grid>
        }
      </ModalOrDrawer>
    );
  }

  return (
    <>
      <DandDButtonBox
        name={ "Manage Inventory" }
        disabled={disabled}
        onClick={() => {
          setOpen(true);
        }}
      />
      { renderExtras() }
    </>
  )
}
